"use client"

import clsx from "clsx"

import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { useCollectionGridSize } from "~/managers/CollectionManager"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

export const DESKTOP_LAYOUTS = ["large", "small"] as const
export const MOBILE_LAYOUTS = ["small", "large"] as const

export function ProductGridControls() {
  const [collectionGridSize, setCollectionGridSize] = useCollectionGridSize()
  const t = useTranslate()

  return (
    <>
      <div className={css.HeaderControls}>
        {DESKTOP_LAYOUTS.map((layout) => (
          <button
            className={sprinkles({ cursor: "pointer" })}
            onClick={() => {
              setCollectionGridSize(layout)
            }}
            aria-label={t("aria_collections_layout_switch", { layout })}
            key={`desktop-${layout}`}
          >
            {layout === "large" && (
              <ul className={css.DesktopLayoutLarge}>
                {Array.from({ length: 3 }).map((_, i) => (
                  <span className={clsx({ [css.isActive]: collectionGridSize === layout })} key={i}></span>
                ))}
              </ul>
            )}
            {layout === "small" && (
              <ul className={css.DesktopLayoutSmall}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <span className={clsx({ [css.isActive]: collectionGridSize === layout })} key={i}></span>
                ))}
              </ul>
            )}
          </button>
        ))}
      </div>

      <div className={css.HeaderControlsMobile}>
        {MOBILE_LAYOUTS.map((layout) => (
          <button
            className={sprinkles({ cursor: "pointer" })}
            onClick={() => {
              setCollectionGridSize(layout)
            }}
            key={`mobile-${layout}`}
            aria-label={t("aria_collections_layout_switch", { layout })}
          >
            {layout === "large" && (
              <div className={clsx(css.MobileLayoutLarge, { [css.isActive]: collectionGridSize === layout })}></div>
            )}
            {layout === "small" && (
              <ul className={css.MobileLayoutSmall}>
                {Array.from({ length: 4 }).map((_, i) => (
                  <span className={clsx({ [css.isActive]: collectionGridSize === layout })} key={i}></span>
                ))}
              </ul>
            )}
          </button>
        ))}
      </div>
    </>
  )
}
